<template>
    <cadastro-simples-form
        endpoint="cbo"
        rota-base="/admin/cbo"
        titulo-singular="CBO"
        :campos-extras='[{"campo":"codigo","label":"Código CBO","tipo":"string","maxLength":10}]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
